import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addCartItem } from "actions/cart";
import { trackAddToCart } from "services/analytics";
import { OPEN_CART, RESET_REMOVE_COUNT } from "utils/action-types";
import navigate from "helpers/navigate";
import { useGlobalContext } from "context/global";
import Loader from "components/loader";
import useToggle from "hooks/useToggle";
import clsx from "clsx/lite";

const AddToCart = ({ product, text, className, callback, openCart = false, showLoader = false }) => {
	const { translation } = useGlobalContext();
	const [isLoading, toggleLoading] = useToggle();
	const cart = useSelector(state => state.cart);
	const dispatch = useDispatch();
	const { authenticated } = useSelector(state => state.account.profile);
	const [buttonWidth, setButtonWidth] = useState(null);
	const buttonRef = useRef(null);

	const isAvailable = ["available", "one-time"].includes(product?.variant?.stock) && product?.variant?.price > 0;

	const updateLoading = () => {
		if (showLoader) toggleLoading();
	};

	useEffect(() => {
		if (buttonRef.current && !buttonWidth)
			setButtonWidth(buttonRef.current.offsetWidth);

	}, [buttonWidth]);

	const addVariant = async () => {
		// If product is not available, don't add to cart
		if (!isAvailable) return;

		if (!authenticated && product?.requireLoginToBuy)
			//Removing return is showing modal for a split second
			return navigate("/account/login");

		// If active box not selected yet, redirect to box page
		if (!cart?.activeBox) {
			return navigate("/box");
		}

		updateLoading();
		await dispatch(addCartItem(product.variant?.id, product.variant.stock === "one-time"));

		openCart && dispatch({ type: OPEN_CART });
		dispatch({ type: RESET_REMOVE_COUNT });
		trackAddToCart(product);
		callback && await callback();
		updateLoading();
	};

	let buttonText;

	if (isAvailable)
		buttonText = text ?? (cart?.activeBox ? translation.product?.addToCart : translation.product?.getStarted);
	else
		buttonText = translation.product?.soldOut;

	if (!authenticated && product?.requireLoginToBuy) buttonText = translation.product?.loginToBuy;

	if (!buttonText) return null;

	return (
		<button
			ref={buttonRef}
			style={{ width: (showLoader && isLoading && buttonWidth) ? buttonWidth : "auto" }}
			disabled={!isAvailable} onClick={addVariant} className={clsx(className, "btn-primary uppercase")}>
			{showLoader && isLoading ? <Loader ring className="!size-5" /> : buttonText}
		</button>
	);
};

export default AddToCart;
